// extracted by mini-css-extract-plugin
export default {"customDropdownBox":"inputwithDropdown_customDropdownBox__VGQsO","listBox":"inputwithDropdown_listBox__5-WIB"};